const SectionTitle = ({ children, styles }) => (
  <h6
    style={{ color: 'white', fontSize: '13px', fontWeight: 'bold', ...styles }}
  >
    {children}
  </h6>
);

export default SectionTitle;
